<template>
  <Control :title="title" :isEdit="isEdit && enabled" :height="36 + (rows - 1) * 25" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"   :editor="editor"  :enabled="enabled" :tooltip="tooltip" :key="title" :isMultilineText="rows != 1"  :required="required" :keyfield="keyfield">
    <template slot="read">
      <div  :class="{cx_autolink:linkFormat, cx_textbox_read:rows==1,cx_textbox_read_rows: rows != 1}" @click="onLinkClicked">{{ value2 }}</div>
    </template>
    <template slot="edit">
      <b-form-input ref="target" :class="{ 'is-invalid': validator.isInvalid }" v-model="internalValue" :type="isPassword ? 'password':'text'" :placeholder="placeholder" autocomplete="off" size="sm" v-if="rows == 1"></b-form-input>
      <textarea class="cx_textarea" :class="{ 'is-invalid': validator.isInvalid }" :rows="rows" v-if="rows != 1" v-model="internalValue" :placeholder="placeholder"></textarea>
    </template>
    <template slot="func">
      <slot name="func"></slot>
    </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class TextBox extends Vue {
  @Prop({ default: '' }) public title?: string;
  @Prop({ default: '' }) public value?: string;
  @Prop({ default: '' }) public placeholder?: string;

  @Prop({ default: null }) public length?: number;
  @Prop({ default: false }) public required?: boolean;
  @Prop({default:false}) public keyfield: boolean;      
  @Prop({ default: null }) public regex: string;
  @Prop({ default: null }) public regexMessage: string;
  @Prop({ default: 1 }) public rows: number;

  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;  
  @Prop() public tooltip: string;
  @Prop() public linkFormat: string;
  @Prop({ default: false }) public isPassword: boolean;

  public isEdit: boolean = true;
  public validator: Components.ControlValidator;
  
  public get value2(){
    return this.value && this.isPassword ? this.value.replace(/./g,'*'): this.value;
  }
  created() {
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }

  mounted() {
    this.validator.update();
  }
  public get internalValue(): string {
    return this.value;
  }
  // public get readValue():string{
  //   return this.value.replace(/\r?\n/g,'<br>');
  // }
  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.validator.update();
  }

  public internalValidate(): string {
    const value = this.internalValue;
    if (this.required && (value == undefined || value == null || value.length == 0)) {
      return '必須項目です';
    }
    if (this.length != undefined && value != undefined && value != null && value.length > this.length) {
      return '入力可能な文字数は' + this.length + '文字です';
    }
    //正規表現チェックは文字入力がある場合のみ適用
    if (this.regex != undefined && value != null && value.length > 0) {
      if (value.match(this.regex) == null) {
        return this.regexMessage;
      }
    }

    return '';
  }

  public onLinkClicked(){
    if (this.linkFormat){
      this.$router.push(String.format(this.linkFormat, this.value));       
    }
  }      
}
</script>
<style lang="scss">
.cx_textarea {
  resize: none;
  width: 100%;
  border-radius: 0.2rem;
  border-color: #ced4da;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  color: #495057;
  display: block;
  outline: none;
  box-shadow: none;  
  &.is-invalid {
    border-color: red !important;
  }
  &:focus{
    border-color: #80bdff; 
  }
}

.cx_textbox_read {
  /* font-family: "Avenir, Helvetica, Arial, sans-serif";
  font-size: 1rem; */
  white-space: pre;
  overflow-x: hidden;
}
.cx_textbox_read_rows {
  /* font-family: "Avenir, Helvetica, Arial, sans-serif";
  font-size: 1rem; */
  word-break: break-word;
  white-space: pre-line;
  overflow-x: hidden;
  height: 80%;
}

</style>
